


<div class="cart-and-order-table">
    <div class="row row-header row-bottom-bordered">
        <div class="col-lg-4 col-md-4 col-sm-4">Product</div>
        <div class="col-lg-1 col-md-1 col-sm-1 text-right col-quantity">Quantity</div>
        <div class="col-lg-1 col-md-1 col-sm-1 text-right col-price">Price</div>
        <div class="col-lg-2 col-md-2 col-sm-2">Delivery Address</div>
        <div class="col-lg-2 col-md-2 col-sm-2 text-right">Orderdate</div>
        <div class="col-lg-2 col-md-2 col-sm-2 text-right">Expected</div>
    </div>

    <app-backorder-table-row *ngFor="let backorder of backorders"></app-backorder-table-row>
       
  
</div>
   
